/* eslint-disable no-underscore-dangle */
/* eslint-disable no-return-assign */
/* eslint-disable no-restricted-globals */
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  formatText,
  getDefaultAlertProps,
  selectTheme,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { LectionSlideDto } from '../../dto/LectionImageDto';
import { LectionDivSlideItem } from './LectionDivSlideItem';
import { API_STATUS_PROBLEM, DARK_THEME } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { IApiResult } from '../../interface/IApiResult';
import { apiGetLection } from '../../service/apiGetLection';
import classes from './LictionDiv.module.css';
import { ImageBase6444Dto } from '../../dto/ImageBase6444Dto';
import { apiGetLectionImage } from '../../service/apiGetLectionImage';
import { useIndexedDB } from '../../service/useIndexedDB';

interface Props {
  isCesh: boolean;
  screenShot: number;
  selectThemeFromMain: number;
  selectPosition: number;
  onChange: (e: any) => void;
  onChange2: (e: any) => void;
  onChange5: (e: any) => void;
}

export const LectionDiv: FunctionComponent<Props> = ({
  isCesh,
  screenShot,
  selectThemeFromMain,
  selectPosition,
  onChange,
  onChange2,
  onChange5,
}) => {
  const { section, lectionId, main, secondary, secondaryBlack } = useParams();
  const [lectionDtos, setLectionDtos] = useState<LectionSlideDto[]>([]);
  const [lectionImageDtos, setLectionImagesDtos] = useState<ImageBase6444Dto[]>(
    []
  );
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const { isReady, setItem, getItem, removeItem, clearAll } = useIndexedDB(
    'LectionsDB',
    'lections',
    isCesh
  );

  const getLectionsFromDb = async () => {
    try {
      const data = await getItem(`lection_${section}_${lectionId}`);
      if (data && lectionDtos.length === 0) {
        // console.log(data);
        setLectionDtos(formatText(data));
      }
    } catch (error) {
      /* empty */
    }
  };

  const getLectionImagesFromDb = async () => {
    try {
      const data = await getItem(`images_${section}_${lectionId}`);
      if (data && lectionImageDtos.length === 0) {
        // console.log(data);
        setLectionImagesDtos(data);
      }
    } catch (error) {
      /* empty */
    }
  };

  const getLectionsFromApi = async () => {
    const apiResult: IApiResult = await apiGetLection(
      section ?? '',
      lectionId ?? '',
      main ?? '',
      secondary ?? '',
      secondaryBlack ?? ''
    );
    if (apiResult.isSuccess) {
      if (lectionDtos.length === 0) {
        setLectionDtos(formatText(apiResult.data));
      }
      if (isCesh) {
        await setItem(`lection_${section}_${lectionId}`, apiResult.data);
      }
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const getLectionImagesFromApi = async () => {
    const apiResult: IApiResult = await apiGetLectionImage(
      section ?? '',
      lectionId ?? ''
    );
    if (apiResult.isSuccess) {
      if (lectionImageDtos.length === 0) {
        setLectionImagesDtos(apiResult.data);
      }
      if (isCesh) {
        await setItem(`images_${section}_${lectionId}`, apiResult.data);
      }
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const getLectionsSposobMatur = async () => {
    if (isCesh) {
      await getLectionsFromDb();
      await getLectionImagesFromDb();
    }

    getLectionsFromApi();
    getLectionImagesFromApi();
  };

  useEffect(() => {
    if (isReady || !isCesh) {
      getLectionsSposobMatur();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, isCesh]);

  const [showOverlay, setShowOverlay] = useState(false);

  const triggerProtection = useCallback(
    (reason = 'попытка скриншота/записи') => {
      // Показываем алерт
      setAlertProps({
        message: `Сделан скриншот. Конспекты заблокированы`,
        severity: AlertSeverityEnum.error,
      });

      // Показываем overlay защиту
      setShowOverlay(true);

      // Автоматически скрываем через 2 секунды
      setTimeout(() => {
        setShowOverlay(false);
      }, 300000);

      // Автоматически скрываем алерт через 3 секунды
      setTimeout(() => {
        setAlertProps(getDefaultAlertProps());
      }, 3000);
    },
    []
  );

  useEffect(() => {
    // Определяем устройство

    // 1. Обработчик клавиш (для десктопов)
    const handleKeyDown = (e: any) => {
      // Windows/Linux: PrintScreen
      if (
        e.key === 'PrintScreen' ||
        e.altKey ||
        e.shiftKey ||
        e.metaKey ||
        e.ctrlKey ||
        e.key === 'F12'
      ) {
        triggerProtection('Сделан скриншот');
        e.preventDefault();
      }
    };

    /*
    // 2. Обработчик visibility change (для мобильных)
    let lastHideTime = 0;
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Запоминаем время когда свернули
        lastHideTime = Date.now();
      } else {
        // Проверяем как быстро вернулись
        const timeHidden = Date.now() - lastHideTime;

        if (timeHidden < 1500 && isMobile) {
          // Быстро свернули и развернули - возможно скриншот
          triggerProtection('возможный скриншот (быстрое сворачивание)');
        }
      }
    };

    // 3. Обработчик pagehide (iOS)
    const handlePageHide = () => {
      if (isiPhone || isiPad) {
        triggerProtection('возможный скриншот/запись (iOS)');
      }
    };

    // 4. Обработчик resize (iOS скриншоты меняют размер)
    let lastWidth = window.innerWidth;
    let lastHeight = window.innerHeight;
    const handleResize = () => {
      if (isiPhone || isiPad) {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;

        // iOS меняет размер окна при скриншоте на несколько пикселей
        const widthDiff = Math.abs(newWidth - lastWidth);
        const heightDiff = Math.abs(newHeight - lastHeight);

        if (
          (widthDiff > 5 || heightDiff > 5) &&
          widthDiff < 50 &&
          heightDiff < 50
        ) {
          // Небольшое изменение размера (не поворот экрана)
          console.log(
            `iOS: Изменение размера ${widthDiff}x${heightDiff} - ВОЗМОЖНО СКРИНШОТ`
          );
          triggerProtection('скриншот (iOS)');
        }

        lastWidth = newWidth;
        lastHeight = newHeight;
      }
    };

    // 5. Обработчик blur/focus (дополнительная защита)
    const handleBlur = () => {
      if (!isMobile) {
        setTimeout(() => {
          if (!document.hasFocus()) {
            triggerProtection('переключение окна');
          }
        }, 100);
      }
    };
    */

    // Вешаем все обработчики
    document.addEventListener('keydown', handleKeyDown);
    // document.addEventListener('visibilitychange', handleVisibilityChange);
    // window.addEventListener('pagehide', handlePageHide);
    // window.addEventListener('resize', handleResize);
    // window.addEventListener('blur', handleBlur);

    // Очистка
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      // document.removeEventListener('visibilitychange', handleVisibilityChange);
      // window.removeEventListener('pagehide', handlePageHide);
      // window.removeEventListener('resize', handleResize);
      // window.removeEventListener('blur', handleBlur);
    };
  }, [triggerProtection]);

  useEffect(() => {
    if (screenShot === 1) {
      triggerProtection('Сделан скриншот');
    }
  }, [screenShot, triggerProtection]);

  return (
    <div
      style={{
        touchAction: 'pan-x',
        overflow: 'hidden',
        overscrollBehavior: 'none',
        userSelect: 'none',
        background: selectTheme(
          '#FFFFFF;#1D2228',
          selectThemeFromMain ?? DARK_THEME,
          -1
        ),
      }}
      className={classes.myDiv4}
    >
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      {lectionDtos.length > 0 && !showOverlay && (
        <LectionDivSlideItem
          isPopup={false}
          dto={lectionDtos}
          dtoImagesBase6444={lectionImageDtos}
          themeFromMain={selectThemeFromMain ?? DARK_THEME}
          selectPosition={selectPosition}
          onChange={onChange}
          onChange2={onChange2}
          onChange5={onChange5}
        />
      )}
      {!(lectionDtos.length > 0) && (
        <CircularProgress
          className={classes.divProgress}
          size={40}
          sx={{ color: '#00c7d3' }}
        />
      )}
    </div>
  );
};
